import React, { PropTypes } from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import actions from "actions";

class CpdSuperhostLocker extends React.Component {
  render() {
    const is_recorded = !!window.location.pathname.match(/recorded/);

    const {
      location: { pathname },
    } = this.props;

    const areLiveWebinars = pathname === "/cpd" || pathname.includes("live");
    const areRecordedWebinars = pathname.includes("recorded");

    return (
      <main className="site--width">
        <div className="container_cpd row">
          <h2 className="main_title">
            {is_recorded
              ? "RECORDED WEBINARS VIEWED"
              : "LIVE WEBINARS ATTENDED"}
          </h2>
          <div className="container_tabs col s12">
            <ul className="tabs cpd_tabs">
              <li className="tab col s2">
                <Link
                  className={areLiveWebinars ? "active" : ""}
                  to="/cpd/live"
                >
                  Webinars Attended - Live
                </Link>
              </li>
              <li className="tab col s2">
                <Link
                  className={areRecordedWebinars ? "active" : ""}
                  to="/cpd/recorded"
                >
                  Webinars Viewed - Recorded
                </Link>
              </li>
            </ul>
          </div>
          {this.props.children}
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CpdSuperhostLocker);



// WEBPACK FOOTER //
// ./src/containers/CpdSuperhost/CpdSuperhostLocker.jsx